import { useSelector } from 'react-redux';
import { getProcessedListSelector } from 'bento-ordering/base/reducers/bentoApi';

const EXTERNALLY_LINKED = 'externally_linked';
function useExternalPromotion() {
  const promotionsState = useSelector(state => state.promotions);
  const allPromotions = getProcessedListSelector(promotionsState);
  const externallyLinkedPromotion =
    allPromotions.find(
      promotion => promotion.entry_type === EXTERNALLY_LINKED
    ) || null;
  const error = promotionsState.error[0] || null;

  return { externallyLinkedPromotion, error };
}

export default useExternalPromotion;
